import { useTranslation } from 'react-i18next';
import { categoryFeatures, categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4 mb-14">
          <h2 className="text-foreground-950 font-heading text-3xl md:text-4xl lg:text-5xl font-bold leading-tight">
            {t('categories.title1')}
            <br />
            {t('categories.title2')}
          </h2>
          <p className="text-foreground-500 text-sm max-w-xs">
            {t('categories.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {categoryFeatures.map((feature) => (
            <a
              key={feature.name}
              href={feature.category.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-100 rounded-2xl overflow-hidden hover:bg-background-200/70 transition-colors cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.name}
                  title={`Itaobuy Spreadsheet ${feature.name}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <h3 className="text-foreground-950 font-heading text-lg font-semibold mb-2">
                  {feature.name}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-4">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col bg-background-100 border border-background-200/50 rounded-2xl overflow-hidden hover:border-background-300/60 hover:bg-background-100/80 transition-all cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.displayName}
                  title={`Itaobuy Sheet ${cat.displayName}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex items-center gap-2 px-3 py-2.5">
                <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
                  <i className={`${cat.icon} text-sm`}></i>
                </span>
                <span className="text-xs text-foreground-700 group-hover:text-foreground-950 transition-colors whitespace-nowrap">
                  {cat.displayName}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}